import { useSimProductsFetch } from './useSimProductsFetch';
import { useSimProductsPagination } from 'products/sim/hooks/useSimProductPagination.ts';

export const useSimProducts = () => {
  const { data: simProducts, isRefetching } = useSimProductsFetch();

  const { status, data: pagination } = useSimProductsPagination();

  return {
    pagination: {
      totalNumberOfItems: status === 'success' ? pagination?.totalNumberOfItems : -1,
    },
    simProducts,
    isRefetching,
  };
};
